import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//获取品牌
export const getBrandList = (params={}) => {
    const url = adminApi  + 'OtaReport/brand'
    return http.fetchGet(url, params);
}
//获取品牌下的筛选项
export const getBrandFilter = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/brandFilter';
    return http.fetchPost(url, params, res_params);
}
//获取ota时间轴
export const getOtaList = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/otaList';
    return http.fetchPost(url, params, res_params);
}
//获取ota时间轴
export const getOtaDetail = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/otaDetail';
    return http.fetchPost(url, params, res_params);
}
